import { render, staticRenderFns } from "./CambioDescrizioneScreenshotDelClickInMassa.vue?vue&type=template&id=82405d88"
import script from "./CambioDescrizioneScreenshotDelClickInMassa.vue?vue&type=script&lang=js"
export * from "./CambioDescrizioneScreenshotDelClickInMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports